import { ApiEndpointBuilder } from "@/services/api/types";
import { ProrateResponse } from "../types";
import { UpdateSubscriptionRequest } from "@/store/tenants/endpoints/tenants";

const updateSubscriptionCheckout = (builder: ApiEndpointBuilder) => {
  return builder.mutation<ProrateResponse, UpdateSubscriptionRequest>({
    query: request => ({
      url: `/checkout/subscription`,
      method: "PUT",
      body: request,
    }),
    invalidatesTags: ["currentPlanCheckout"],
  });
};
export default updateSubscriptionCheckout;
